import React, { useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router';

export const MakeJoinConferenceFactory: React.FC = () => {
  const { search } = useLocation();
  const { push } = useHistory();

  /**
   * t: short
   * u: userName
   * m: mic
   * c: cam
   * sr: sacRequest
   */

  const params = useMemo(
    () => ({
      t: new URLSearchParams(search).get('t') ?? null,
      u: new URLSearchParams(search).get('u') ?? undefined,
      m: new URLSearchParams(search).get('m') ?? false,
      c: new URLSearchParams(search).get('c') ?? false,
      sr: new URLSearchParams(search).get('sr') ?? null,
      sessionName: new URLSearchParams(search).get('sessionName') ?? null,
      ak: new URLSearchParams(search).get('ak') ?? undefined,
    }),
    [search],
  );

  useEffect(() => {
    if (params?.t) {
      let query = '';

      Object.entries(params).forEach(([key, value], index) => {
        if (value) query += `${index ? '&' : ''}${key}=${value}`;
      });

      push(`/appointment/conf?${query}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [push, search]);

  return <></>;
};
